
(function () {
  'use strict';

  if (window.__pocoCarouselEager) return;
  window.__pocoCarouselEager = true;

  var SELECTOR = '.swipecollection, .swiper.swipecollection, .swiper-wrapper';

  function eager(root) {
    if (!root || root.dataset.eagerDone === '1') return;
    root.dataset.eagerDone = '1';

    root.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (!img.getClientRects().length) return;
      img.loading = 'eager';
      /* Setting .loading alone does not always kick off a fetch for an image
         the browser has already skipped, so nudge the source as well. */
      if (img.dataset.src && !img.src) img.src = img.dataset.src;
      if (img.dataset.srcset && !img.srcset) img.srcset = img.dataset.srcset;
    });
  }

  var MARGIN = 600;

  /* Scroll-driven sweep. IntersectionObserver alone was not enough: on some
     sections it never delivered a callback, leaving those rows lazy. This runs
     off the same numbers and does not depend on the observer firing. */
  function sweep() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll(SELECTOR).forEach(function (c) {
      if (c.dataset.eagerDone === '1') return;
      var r = c.getBoundingClientRect();
      if (r.bottom > -MARGIN && r.top < vh + MARGIN) eager(c);
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      sweep();
    });
  }

  function watch() {
    var carousels = document.querySelectorAll(SELECTOR);
    if (!carousels.length) return;

    if (document.readyState === 'complete') sweep();

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            eager(e.target);
            io.unobserve(e.target);
          });
        },
        /* Start a screen early so the row is ready before it is reached. */
        { rootMargin: MARGIN + 'px 0px' }
      );

      var startIO = function () {
        carousels.forEach(function (c) {
          io.observe(c);
        });
      };
      if (document.readyState === 'complete') startIO();
      else window.addEventListener('load', startIO, { once: true });
    }
  }

  window.addEventListener('scroll', function () {
    if (document.readyState === 'complete') onScroll();
  }, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('load', sweep);

  /* A swipe is proof the shopper wants the rest of the row now. Both events
     are bound because Swiper swallows one or the other depending on the
     browser's touch/pointer support. */
  function onPoke(e) {
    if (!e.target || !e.target.closest) return;
    eager(e.target.closest(SELECTOR));
  }

  document.addEventListener('pointerdown', onPoke, { passive: true });
  document.addEventListener('touchstart', onPoke, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }

  /* Sections re-render in the theme editor. */
  document.addEventListener('shopify:section:load', watch);
})();
